"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacilitiesManagerStatus = exports.getEmptyFacilitiesManager = void 0;
var Help_1 = __importDefault(require("./Help"));
var FacilitiesManagerStatus;
(function (FacilitiesManagerStatus) {
    FacilitiesManagerStatus[FacilitiesManagerStatus["inProgress"] = 1] = "inProgress";
    FacilitiesManagerStatus[FacilitiesManagerStatus["saved"] = 2] = "saved";
})(FacilitiesManagerStatus || (FacilitiesManagerStatus = {}));
exports.FacilitiesManagerStatus = FacilitiesManagerStatus;
var emptyFacilitiesManagerSpec = {
    id: null,
    status: FacilitiesManagerStatus.inProgress,
    details: {
        name: null,
        publish: true,
        description: null,
    },
    contact: {
        website: null,
        contactWebsite: null,
        primaryContactId: null,
    },
    files: {
        list: [],
        logos: []
    }
};
function getEmptyFacilitiesManager() {
    return Help_1.default.deepCloneObject(emptyFacilitiesManagerSpec);
}
exports.getEmptyFacilitiesManager = getEmptyFacilitiesManager;
//# sourceMappingURL=facilitiesManagerSpec.js.map